<template>
  <div>
    <headers></headers>
    <div class="bg">
      <div class="swiper">
        <el-carousel indicator-position="outside">
          <el-carousel-item v-for="item in 4" :key="item">
            <el-image :src="banner"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- <div class="classify">
      <div class="w_1400">
        <div class="classify-box">
          <div class="item" v-for="(item,index) in filterList">
            <div>{{item.title}}:</div>
            <ul>

              <el-tag v-for="(tag,key) in item.value" :key="key" :effect="item.select==key?'dark':'plain'"
                :type="item.select==key?'success':'info'" @click="tagchange(index,key)">
                {{tag}}
              </el-tag>
            </ul>
          </div>


        </div>
      </div>
    </div> -->

    <div class="list-course">
      <div class="w_1400">
        <ul v-if="courseList.length">
          <li v-for="item in courseList" @click="godet(item.id)">

            <div class="list-course-img">
              <img :src="item.image" alt="">
              <span>47节</span>
            </div>
            <div class="list-course-txt">
              <h3>
                <!-- <span><i>{{item.teacher.nickname}}</i></span> -->
              {{item.name}}</h3>
              <p><span>{{item.visitors}}</span>人观看</p>
            </div>
          </li>
        </ul>
        <el-empty description="搜索结果为空" v-else></el-empty>
      </div>
    </div>
    <div style="text-align: center;">
      <el-pagination layout="prev, pager, next" :total="total" @next-click="nextpage" @prev-click="prevpage"
        :page-size="12" @current-change="currentchange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import {
    search
  } from '../../request/api';
  export default {
    name: 'app',
    components: {
      headers
    },
    data() {
      return {
        banner: require('../../assets/banner1.png'),
        courseList: [],
        total: 0,
        filter: {},
        page: 1,
        filterList: '',
        tralist: '',
        page1: 1,
        courseshow: true
      }
    },
    methods: {
      traininglist() {
        traininglist({
          page: this.page1,
          pageSize: 10
        }).then(res => {
          this.tralist = res.data.data
        })
      },
      godet(id) {
        if (this.type == 1) {
          this.$router.push({
            name: 'coursewaredet',
            query: {
              id
            }
          })
        } else {
          this.$router.push({
            name: 'tradet',
            query: {
              id
            }
          })
        }
      },
      tagchange(index, key) {
        if (key != 0) {
          this.filterList[index].select = key
          this.filter[this.filterList[index].name] = key
          this.courselist()
        } else {
          this.filterList[index].select = key
          this.filter[this.filterList[index].name] = undefined
          this.courselist()
        }
      },
      courselist() {
        allList({
          page: this.page,
          pageSize: 10,
          filter: JSON.stringify(this.filter)
        }).then(res => {
          if (res.code) {
            this.courseList = res.data.data
            this.total = res.data.total
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 点击了下一页时触发的方法
      nextpage() {
        this.page++
        this.courselist()
      },
      // 点击了上一页时触发的方法
      prevpage() {
        this.page--
        this.courselist()
      },
      // page被改变时触发的方法
      currentchange(event) {
        this.page = event
        this.courselist()
      },
      filterchange() {
        this.filter.id = 99
        this.filter.name = "789"
        this.filter.aaaa = "789"
        this.courselist()
      },
      getSelect() {
        getSelect().then(res => {
          this.filterList = res.data.map(item => {
            item.select = 0
            item.value[0] = '全部'
            return item
          })
        })
      }
    },
    created() {
      this.type = this.$route.query.type
      search({
        keyword: this.$route.query.keyword,
        type: this.$route.query.type
      }).then(res => {
        console.log(res)
        this.courseList = res.data.data
      })
    },
    watch: {
    			// 路由变化就是刷新数据，为了解决子级跳转到这个页面，数据不刷新问题
    			'$route': {
    				handler() {
    					if (this.$route.query.keyword) {
    						search({
    						  keyword: this.$route.query.keyword,
    						  type: this.$route.query.type
    						}).then(res => {
    						  console.log(res)
    						  this.courseList = res.data.data
    						})
    					}
    				},
    				immediate: true
    			}
    		},
  }
</script>

<style>
  @import url('../../assets/css/home.css');

  html {
    height: 100%;
  }

  body {
    padding: 0px;
    margin: 0px;
    height: 100%;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
  }

  .bg {
    background: url('../../assets/study_bg.png') no-repeat top;
    padding-top: 1px;
    background-size: 1920px 400px;
    width: 1290px;
    height: auto;
    position: relative;
    margin: auto;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }



  .swiper {
    width: 70%;
    height: 400px;
    margin: 60px auto 0 auto;
  }

  .el-carousel__indicators--outside {
    height: 22px;
    line-height: 22px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 25px 25px 25px 25px;
    width: 100px;
    margin: 0 auto;
    margin-top: -20px;
    position: absolute;
    bottom: 20px;
  }

  .el-carousel__indicators--outside button {
    width: 7px;
    height: 7px;
    opacity: 1;
    border: 1px solid #FFFFFF;
    background: transparent;
    border-radius: 100%;
  }

  .el-carousel__indicator.is-active button {
    background: #FFFFFF;
  }

  .el-carousel--horizontal {
    overflow: hidden;
  }

  .el-carousel__container {
    height: 400px !important;
  }

  .el-carousel__indicator--horizontal {
    padding: 0 4px;
  }

  .el-tag {
    margin-right: 20px;
    cursor: pointer;
  }

  .el-tag--plain.el-tag--info {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/search.vue